import * as OriginalPropTypes$1 from 'prop-types';
var EnvPropTypes; // In the dev build of Recollect, we wrap PropTypes in a proxy so we can
// mute the store while the prop types library reads the props.

{
  // For prod builds, just use the normal PropTypes which is a no-op
  EnvPropTypes = OriginalPropTypes$1;
} // We do this so we're exporting a const (EnvPropTypes is a let)

var PropTypes = EnvPropTypes;
export default PropTypes;